const drawerWidth = 300;

export default drawerWidth;
